import { useEffect, useState } from 'react';
import { resolveMediaUrl, getVideoMimeType } from '../lib/mediaUrl';
import { fetchJsonCached } from '../lib/settingsCache';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Single source of truth for the hero overlay media.
 *
 * Reads GET /api/settings/hero-display, which is written by
 * Developer Settings -> Hero Media. Any video ever uploaded there is picked up
 * here automatically - nothing about the media is hardcoded in the UI.
 */
export const useHeroMedia = () => {
  const [media, setMedia] = useState({
    videoUrl: '',
    videoMimeType: '',
    backgroundImageUrl: '',
    cardImageUrl: '',
    cardTitle: '',
    cardSubtitle: '',
    cardDescription: '',
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;

    const fetchHeroMedia = async () => {
      try {
        const data = await fetchJsonCached(`${API_URL}/api/settings/hero-display`);
        if (cancelled) return;
        const videoUrl = resolveMediaUrl(data?.hero_video_url);
        setMedia({
          videoUrl,
          videoMimeType: videoUrl ? getVideoMimeType(data?.hero_video_url) : '',
          backgroundImageUrl: resolveMediaUrl(data?.hero_background_image_url),
          cardImageUrl: resolveMediaUrl(data?.hero_card_image_url),
          cardTitle: data?.hero_card_title || '',
          cardSubtitle: data?.hero_card_subtitle || '',
          cardDescription: data?.hero_card_description || '',
          loading: false,
        });
      } catch (error) {
        if (!cancelled) setMedia((prev) => ({ ...prev, loading: false }));
      }
    };

    fetchHeroMedia();
    return () => {
      cancelled = true;
    };
  }, []);

  return media;
};

export default useHeroMedia;
